import type { FanoutSlice, TimeframeFanout } from '~/api/hooks/useTimeframeFanout'

/** Narrow a CP timeframe-fanout for the Columns fan-out: keep only rows whose `columnsDim` equals
 *  `value` (or all rows when `value` is undefined — the strip-only path used for the shared colour
 *  map + scale), and remove `columnsDim` from each surviving row's `dims` so the bars rank by the
 *  REMAINING group-by. Pure; preserves every other field. */
export function narrowFanoutToColumn(
  arm: TimeframeFanout,
  columnsDim: string,
  value?: string,
): TimeframeFanout {
  const narrowSlice = (s: FanoutSlice): FanoutSlice => ({
    ...s,
    rows: s.rows
      .filter((r) => value === undefined || r.dims?.[columnsDim] === value)
      .map((r) => {
        if (!r.dims) return r
        const { [columnsDim]: _omit, ...rest } = r.dims
        return { ...r, dims: rest }
      }),
  })
  return { ...arm, byTimeframe: arm.byTimeframe.map(narrowSlice) }
}
